import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IKisi_View_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IKisi_View_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  SelectKisi: any[];
  SelectKisi_dummy: any[];
}

export class Kisi_View_ScreenBase extends React.PureComponent<
  IKisi_View_ScreenProps,
  any
> {
  ml = [
    {
      Id: "bd00ad4a-ed44-61e3-4813-27fcfc1bccc8",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9f0b40ca-a5d3-4b72-bc52-230e83587430",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "a0d50073-5eb3-4a6e-9c9d-c0fb64ecf015",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 796540, PropertyName: "value", Value: "Kisi View" },
        { Id: 7249851, PropertyName: "value", Value: "Ad" },
        { Id: 2508763, PropertyName: "value", Value: "AdSoyad" },
        { Id: 4157390, PropertyName: "value", Value: "CepTelefonu" },
        { Id: 7597293, PropertyName: "value", Value: "Eposta" },
        { Id: 1713048, PropertyName: "value", Value: "IsBakimci" },
        { Id: 1904518, PropertyName: "value", Value: "IsMurettebat" },
        { Id: 9772308, PropertyName: "value", Value: "IsYolcu" },
        { Id: 1746637, PropertyName: "value", Value: "Kilo" },
        { Id: 9084935, PropertyName: "value", Value: "Soyad" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      SelectKisi: [],
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("kisi_view", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.Kisi_ViewPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("kisi_view", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("kisi_view", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.Kisi_ViewPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  Kisi_ViewPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Kisi_View/Kisi_ViewPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectKisi = result?.data.selectKisi;
    formVars.kisi_view_2149295_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].ad
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].ad
        : null
    );
    formVars.kisi_view_4630940_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].adSoyad
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].adSoyad
        : null
    );
    formVars.kisi_view_1613070_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].cepTelefonu
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].cepTelefonu
        : null
    );
    formVars.kisi_view_5315539_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].eposta
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].eposta
        : null
    );
    formVars.kisi_view_2183386_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].isBakimci
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].isBakimci
        : null
    );
    formVars.kisi_view_7795559_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].isMurettebat
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].isMurettebat
        : null
    );
    formVars.kisi_view_3313702_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].isYolcu
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].isYolcu
        : null
    );
    formVars.kisi_view_9587493_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].kilo
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].kilo
        : null
    );
    formVars.kisi_view_3489417_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].soyad
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].soyad
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Kisi_ViewPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Kisi_ViewPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.kisi_view_2149295_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].ad
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].ad
        : null
    );

    formVars.kisi_view_4630940_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].adSoyad
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].adSoyad
        : null
    );

    formVars.kisi_view_1613070_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].cepTelefonu
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].cepTelefonu
        : null
    );

    formVars.kisi_view_5315539_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].eposta
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].eposta
        : null
    );

    formVars.kisi_view_2183386_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].isBakimci
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].isBakimci
        : null
    );

    formVars.kisi_view_7795559_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].isMurettebat
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].isMurettebat
        : null
    );

    formVars.kisi_view_3313702_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].isYolcu
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].isYolcu
        : null
    );

    formVars.kisi_view_9587493_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].kilo
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].kilo
        : null
    );

    formVars.kisi_view_3489417_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectKisi !== undefined
        ? stateVars.SelectKisi?.length > 0
          ? stateVars.SelectKisi[0].soyad
          : null
        : this.state.SelectKisi?.length > 0
        ? this.state.SelectKisi[0].soyad
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  Kisi_ViewComponent_968274_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.Kisi_ViewPageInit();
    }
  }
}
